import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SidebarGroupsToggleState = {
  groups: Record<string, boolean>;
  reset: VoidFunction;
  update: (params: { groups: Record<string, boolean> }) => void;
};

export const useSidebarGroupsToggleState = create<SidebarGroupsToggleState>()(
  persist(
    (set) => ({
      groups: {},
      reset: () => set({ groups: {} }),
      update: ({ groups }: { groups: Record<string, boolean> }) => set({ groups }),
    }),
    { name: 'sidebar-groups-toggle' },
  ),
);
